import { MappedClass, MappedProperty } from '@h5s/util-object';

@MappedClass()
export class ZPrinterStringApplicable {
  @MappedProperty()
  is_applicable: boolean;

  @MappedProperty()
  read_only: boolean;

  @MappedProperty()
  value: string;
}
